import { Routes } from '@amzn/atoz-shiftapp-initializer';
import { DateTime } from 'luxon';
export var getSwapPath = function (startTime, pathname) {
    return "".concat(Routes.Swap, "?swapFrom=").concat(DateTime.fromISO(startTime).toISODate(), "&shiftStart=").concat(startTime, "&").concat(new URLSearchParams({
        source: pathname
    }));
};
